export default "__VITE_ASSET__3a72eedb__"